import Layout from '../../layout';
const homeRouter = {
	path: '/',
	component: Layout,
	redirect: '/',
	name: 'medical',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/',
			component: () => import('@/pages/medical/views/home/index.vue'),
			name: 'home',
		},
		{
			path: '/about',
			component: () => import('@/pages/medical/views/about/index.vue'),
			name: 'about',
		},

		{
			path: '/hylist',
			component: () => import('@/pages/medical/views/hylist/index.vue'),
			name: 'hylist',
		},
		{
			path: '/baogao',
			component: () => import('@/pages/medical/views/baogao/index.vue'),
			name: 'hotContent',
		},
		{
			path: '/specialTopic',
			component: () => import('@/pages/medical/views/specialTopic/index.vue'),
			name: 'specialTopic',
		},

	],
};

export default homeRouter;
